class PromiseHelper {

    static timed_promise(timeout) {
        return new Promise((resolve) => setTimeout(resolve, timeout));
    }

    static delayed_promise(promise, limit) {
        return Promise.all([promise, PromiseHelper.timed_promise(limit)]).then((args) => args[0]);
    }

}

export default PromiseHelper;
